import ApplicationController from './application_controller'
import flatpickr from 'flatpickr'

export default class extends ApplicationController {
  static targets = ['input']

  doConnect() {
    this._calendar = flatpickr(this.inputTarget, {})
  }

  clear(event) {
    this._calendar.clear()

    // ie compatibility
    // TODO - Move to a class and standardize dispatching events
    let changeEvent
    if (typeof (Event) === 'function') {
      changeEvent = new Event('change')
    } else {
      changeEvent = document.createEvent('Event')
      changeEvent.initEvent('change', true, true)
    }
    // end ie compatibility

    this.inputTarget.dispatchEvent(changeEvent)
  }

  name() {
    return this.inputTarget.getAttribute('name')
  }

  value() {
    return this.inputTarget.value
  }
}
